(async () => {
  const root = document.querySelector('[data-pilot-precheckout]');
  if (!root) return;
  const form = root.querySelector('form');
  const message = root.querySelector('[role="alert"]');
  const button = root.querySelector('[data-continue]');
  const buttonLabel = button.textContent;
  // Como o checkout da Shopify: "$ 30.960,00", sempre com centavos.
  // Mesmo formato da vitrine ("$26.690"): símbolo colado e sem ",00"; centavos só quando existem (revisão, 05/10/2026).
  const currencySymbol = (() => { try { return new Intl.NumberFormat(root.dataset.locale, { style: 'currency', currency: root.dataset.currency, currencyDisplay: 'narrowSymbol' }).formatToParts(0).find(part => part.type === 'currency')?.value || '$'; } catch { return '$'; } })();
  const money = value => {
    const minor = Math.round(Number(value) || 0), digits = minor % 100 ? 2 : 0;
    return (minor < 0 ? '-' : '') + currencySymbol + new Intl.NumberFormat(root.dataset.locale, { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Math.abs(minor) / 100);
  };
  const imageUrl = value => {
    try {
      const url = new URL(value, location.origin);
      if (url.protocol !== 'https:' || !(url.origin === location.origin || /^(?:cdn\.shopify\.com|[^/]+\.shopifycdn\.com)$/.test(url.hostname))) return null;
      // Miniatura de 64 px: pede 128 px ao CDN em vez da foto original (1000–2000 px).
      url.searchParams.set('width', '128');
      return url.href;
    } catch { return null; }
  };
  const cookie = name => document.cookie.split('; ').find(part => part.startsWith(name + '='))?.slice(name.length + 1) || null;
  // Identificadores para o Meta (fbp/fbc/external_id) e o visitante do Lumetria, gravados no intent.
  const browserSignals = attribution => {
    let visitorId = null;
    try { visitorId = localStorage.getItem('utmify_visitor_id'); } catch {}
    return { fbp: cookie('_fbp'), fbc: cookie('_fbc') || attribution.fbc || null, externalId: cookie('_ck_vid'), visitorId: visitorId || cookie('utmify_visitor_id') };
  };
  const readAttribution = () => { try { return JSON.parse(sessionStorage.getItem('checkout-cart-attribution-v2') || '{}'); } catch { return {}; } };
  // Como no Projeto Final: InitiateCheckout ao abrir esta página (uma vez por carrinho na sessão), pelo pixel
  // da vitrine (navegador + servidor com o mesmo ID); o Lumetria conta o checkout iniciado aqui.
  const trackInitiateCheckout = () => {
    if (!cart?.items?.length) return;
    const key = 'pilot-ic:' + fingerprint(cart);
    try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch {}
    // track.js da Lumetria é async e sem fila: espera ele carregar (até ~8 s) para não perder o "checkout" (auditoria,
    // 09/10/2026). A marca da sessão já foi gravada, então sem a espera o evento nunca saía.
    const lumetriaCheckout = (tries = 0) => {
      if (typeof window.utmifyTrack === 'function') { try { window.utmifyTrack('checkout'); } catch {} return; }
      if (tries < 40) setTimeout(() => lumetriaCheckout(tries + 1), 200);
    };
    lumetriaCheckout();
    const contents = cart.items.map(item => ({ id: item.handle, quantity: item.quantity, item_price: item.final_price / 100 }));
    try {
      if (typeof window.__ckTrack === 'function') window.__ckTrack('InitiateCheckout', 'ic', { content_type: 'product', content_ids: contents.map(item => item.id),
        contents, currency: root.dataset.currency, value: cart.items.reduce((sum, item) => sum + item.original_line_price, 0) / 100,
        num_items: cart.items.reduce((sum, item) => sum + item.quantity, 0) });
    } catch {}
  };
  // AddPaymentInfo no clique que leva ao envío, com o mesmo event_id que o servidor manda ao CAPI.
  // Sem espera: o servidor grava o mesmo evento na fila durável do CAPI (deduplicado pelo eventID).
  const trackAddPaymentInfo = tracking => {
    try { if (typeof window.__ckSetMatching === 'function') window.__ckSetMatching(tracking?.advancedMatching); } catch {}
    const event = tracking?.addPaymentInfo;
    if (!event || typeof window.fbq !== 'function') return;
    const { eventId, ...data } = event;
    try { window.fbq('track', 'AddPaymentInfo', data, { eventID: eventId }); } catch {}
  };
  // Envío montado antes do clique: o servidor só grava o AddPaymentInfo agora (keepalive: sobrevive à troca de página).
  const confirmAddPaymentInfo = active => {
    try {
      fetch('/api/pilot/shipping', { method: 'POST', credentials: 'same-origin', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'confirm', id: active.id, signature: active.signature }) }).catch(() => {});
    } catch {}
  };
  // Deixa o Worker com o token da Shopify pronto antes do clique (GET não cria nada).
  fetch('/api/pilot/checkout', { cache: 'no-store', credentials: 'same-origin' }).catch(() => {});
  let cart;
  let submitting = false;
  let cartValid = false;
  let refreshPromise;
  const fingerprint = value => JSON.stringify(value?.items?.map(item => [String(item.variant_id), item.quantity, item.original_line_price]).sort());
  const nativeShipping = root.dataset.nativeShipping === 'true';
  const shippingKey = 'pilot-shipping:' + root.dataset.checkoutOrigin;
  const informationPanel = root.querySelector('[data-information-panel]');
  const shippingPanel = root.querySelector('[data-shipping-panel]');
  const changeInformation = root.querySelector('[data-change-information]');
  const shippingGroups = root.querySelector('[data-shipping-groups]');
  const summary = root.querySelector('.cp-summary');
  const toggle = root.querySelector('.cp-summary-toggle');
  const informationStep = root.querySelector('[data-information-step]');
  const shippingStep = root.querySelector('[data-shipping-step]');
  let shippingSession = null;
  let shippingState = null;
  // Só em memória: comprador diferente é outra tentativa, com o matching/tracking atual dessa tentativa.
  let shippingBuyerSnapshot = null;
  let shippingVersion = 0;
  let loadingShipping = false;
  // Momento em que o servidor confirmou o estado do envío mostrado (redesenhar o mesmo estado não renova).
  let shippingConfirmedAt = 0;
  let previousDrawn = null;
  // Projeto Final: com os dados completos e válidos, o pedido começa a ser montado antes do clique.
  let ahead = null;
  let aheadTimer = null;
  let aheadCount = 0;
  const aheadDelay = Number(root.dataset.aheadDelay || 500);
  // Validação própria (Projeto Final): o navegador não mostra balões. No F5 os campos podem estar vazios
  // e a sessão assinada já guarda o comprador no servidor.
  form.noValidate = true;
  const BUYER_FIELDS = ['email', 'firstName', 'lastName', 'address1', 'streetNumber', 'address2', 'city', 'province', 'postalCode', 'phone'];
  const formBuyer = () => Object.fromEntries(BUYER_FIELDS.map(name => [name, String(form.elements[name]?.value ?? '')]));
  const buyerSnapshot = () => JSON.stringify(formBuyer());
  const subtotalMinor = () => cart.items.reduce((sum, item) => sum + item.original_line_price, 0);
  const allShippingSelected = () => shippingState?.groups.length > 0 && shippingState.groups.every(group => group.selectedHandle !== null);
  const shippingSessionValid = value => value && typeof value.id === 'string' && value.id.length > 0 && typeof value.signature === 'string' && value.signature.length > 0;
  const onShippingStep = () => informationPanel.hidden === true;
  // Do envío a pessoa vai para outra página (o pagamento da Shopify): o botão e o aviso dizem isso antes,
  // para o layout novo não assustar (como o "Continuar al pago con tarjeta" do Projeto Final).
  const PAY_LABEL = 'Continuar al pago seguro';
  const payRedirect = root.querySelector('[data-pay-redirect]');
  const continueLabel = () => !onShippingStep() ? buttonLabel : shippingState || loadingShipping ? PAY_LABEL : 'Reintentar envío';
  // Mesmo critério do servidor: celular argentino com código de área.
  function phoneValid(value) {
    let digits = String(value || '').replace(/\D/g, '');
    if (digits.startsWith('0054')) digits = digits.slice(4); else if (digits.startsWith('54')) digits = digits.slice(2);
    if (digits.startsWith('0')) digits = digits.slice(1);
    // 12 dígitos = formato com "15" depois do código de área; o servidor confere o código.
    return /^(?:\d{10}|9\d{10})$/.test(digits) || /^\d{2,4}15\d{6,8}$/.test(digits.length === 12 ? digits : '');
  }
  // Validação do Projeto Final: erro em vermelho embaixo do campo, com os mesmos textos.
  const REQUIRED_FIELDS = ['email', 'firstName', 'lastName', 'address1', 'streetNumber', 'postalCode', 'city', 'province', 'phone'];
  function fieldError(name) {
    const value = String(form.elements[name]?.value ?? '').trim();
    // Textos em "vos", como a loja; CEP aceita 1000, C1000 e C1000WAA (revisão, 05/10/2026).
    if (name === 'email') return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? '' : 'Ingresá un correo electrónico válido.';
    if (name === 'phone') return phoneValid(value) ? '' : 'Ingresá un teléfono argentino válido con código de área.';
    if (name === 'postalCode') return /^(?:\d{4}|[A-HJ-NP-Z]\d{4}(?:[A-Z]{3})?)$/i.test(value) ? '' : 'Ingresá un código postal argentino, por ejemplo 1000, C1000 o C1000WAA.';
    if (name === 'province') return value ? '' : 'Elegí una provincia.';
    if (name === 'streetNumber') return /^[\w\s.\-/º°]{1,16}$/.test(value) ? '' : 'Ingresá el número de tu domicilio (o S/N).';
    return value.length >= 2 ? '' : 'Completá este campo.';
  }
  function setError(name, text) {
    root.querySelector(`[data-field="${name}"]`)?.classList.toggle('is-invalid', Boolean(text));
    const output = root.querySelector(`[data-error="${name}"]`);
    if (output) output.textContent = text || '';
    return !text;
  }
  function validateInformation() {
    const valid = REQUIRED_FIELDS.map(name => setError(name, fieldError(name))).every(Boolean);
    if (!valid) root.querySelector('.is-invalid input,.is-invalid select')?.focus();
    return valid;
  }
  const informationReady = () => REQUIRED_FIELDS.every(name => !fieldError(name));
  function drawButton() {
    const label = continueLabel();
    button.textContent = label;
    // Seta "→" do Projeto Final nos dois passos; o "Reintentar" fica sem.
    button.classList.toggle('cp-next', !onShippingStep());
    button.classList.toggle('cp-submit', onShippingStep() && label !== 'Reintentar envío');
    if (payRedirect) payRedirect.hidden = label !== PAY_LABEL;
  }
  function updateControls() {
    button.disabled = submitting || !cartValid || !cart?.items?.length || Boolean(onShippingStep() && shippingState && !allShippingSelected());
    if (changeInformation) changeInformation.disabled = submitting;
    shippingGroups?.querySelectorAll('input').forEach(input => { input.disabled = submitting || !cartValid; });
  }
  function saveShippingPhase(phase) {
    if (!shippingSession) return;
    shippingSession.phase = phase;
    const { id, signature, fingerprint } = shippingSession;
    try { sessionStorage.setItem(shippingKey, JSON.stringify({ id, signature, fingerprint, phase })); } catch {}
  }
  function retainShipping(error) {
    return ['preparing', 'ready'].includes(shippingSession?.phase) && shippingSessionValid(shippingSession) && !error.invalidShipping &&
      cart?.items?.length > 0 && shippingSession.fingerprint === fingerprint(cart);
  }
  // Bolinha girando no próprio botão (Projeto Final: .is-loading), sem texto de "Cargando".
  function setBusy(value, spinner = false) {
    submitting = value;
    button.classList.toggle('is-loading', value && spinner);
    if (value && spinner) button.setAttribute('aria-busy', 'true'); else button.removeAttribute('aria-busy');
    if (!value) drawButton();
    updateControls();
  }
  function showShippingStep(show) {
    informationPanel.hidden = show;
    shippingPanel.hidden = !show;
    // Etapas do Projeto Final: a atual em destaque e a anterior concluída (clicável para voltar).
    informationStep?.classList.toggle('is-active', !show);
    informationStep?.classList.toggle('is-complete', show);
    shippingStep?.classList.toggle('is-active', show);
    root.querySelector('.cp-steps [aria-current]')?.removeAttribute('aria-current');
    (show ? shippingStep : informationStep)?.setAttribute('aria-current', 'step');
    root.dataset.cpStep = show ? '2' : '1';
    // Resumo aberto em Información e recolhido no envío (no celular), como no Projeto Final.
    summary?.classList.toggle('is-open', !show);
    toggle?.setAttribute('aria-expanded', String(!show));
    if (changeInformation) changeInformation.hidden = !show;
    if (!submitting) drawButton();
  }
  function drawTotals() {
    const subtotal = subtotalMinor();
    const total = shippingState ? shippingState.totalMinor : subtotal;
    root.querySelectorAll('[data-subtotal]').forEach(element => { element.textContent = money(subtotal); });
    root.querySelectorAll('[data-estimated-total],.cp-mobile-total').forEach(element => { element.textContent = money(total); });
    const shippingTotal = root.querySelector('[data-shipping-total]');
    if (shippingTotal) {
      shippingTotal.textContent = shippingState ? (shippingState.shippingMinor === 0 ? 'GRATIS' : money(shippingState.shippingMinor)) : 'Calculado en el siguiente paso';
      shippingTotal.classList.toggle('muted', !shippingState);
    }
    const charges = shippingState ? total - subtotal - shippingState.shippingMinor : 0;
    root.querySelectorAll('[data-shipping-charges-label],[data-shipping-charges]').forEach(element => { element.hidden = charges === 0; });
    const chargesValue = root.querySelector('[data-shipping-charges]');
    if (chargesValue) chargesValue.textContent = charges ? money(charges) : '';
  }
  function discardShipping() {
    shippingVersion++;
    shippingSession = null;
    shippingState = null;
    shippingBuyerSnapshot = null;
    loadingShipping = false;
    try { sessionStorage.removeItem(shippingKey); } catch {}
    if (nativeShipping) {
      shippingGroups.replaceChildren();
      root.querySelector('[data-shipping-address]').textContent = '';
      showShippingStep(false);
    }
    if (cart) drawTotals();
    updateControls();
  }
  function validateShipping(data) {
    const minor = value => Number.isSafeInteger(value) && value >= 0;
    const invalid = text => Object.assign(new Error(text), { invalidShipping: true });
    if (!data || data.currency !== root.dataset.currency || (cart.currency && data.currency !== cart.currency) ||
      data.subtotalMinor !== subtotalMinor() || !minor(data.subtotalMinor) || !minor(data.shippingMinor) || !minor(data.totalMinor) ||
      data.totalMinor < data.subtotalMinor + data.shippingMinor || typeof data.address !== 'string' || !Array.isArray(data.groups) ||
      (data.contact !== undefined && typeof data.contact !== 'string') || (data.checkoutUrl !== undefined && typeof data.checkoutUrl !== 'string')) {
      throw invalid('El envío no coincide con tu carrito. Volvé a la información e intentá nuevamente.');
    }
    const ids = new Set();
    let selectedAmount = 0;
    for (const group of data.groups) {
      if (!group || typeof group.id !== 'string' || !group.id || ids.has(group.id) || !Array.isArray(group.options)) throw invalid('No pudimos confirmar las opciones de envío.');
      ids.add(group.id);
      const handles = new Set();
      for (const option of group.options) {
        if (!option || typeof option.handle !== 'string' || !option.handle || handles.has(option.handle) || typeof option.title !== 'string' || !minor(option.amountMinor)) throw invalid('No pudimos confirmar las opciones de envío.');
        handles.add(option.handle);
      }
      if (group.selectedHandle !== null && !handles.has(group.selectedHandle)) throw invalid('No pudimos confirmar el envío seleccionado.');
      selectedAmount += group.options.find(option => option.handle === group.selectedHandle)?.amountMinor || 0;
    }
    if (data.shippingMinor !== selectedAmount) throw invalid('No pudimos confirmar el importe del envío.');
    return data;
  }
  // "Llega entre el lunes 6 de octubre y el jueves 9 de octubre": dias úteis contados de hoje em Buenos Aires.
  function deliveryEstimate(days) {
    if (!Array.isArray(days) || days.length !== 2 || !days.every(Number.isInteger) || days[0] < 0 || days[1] < days[0] || days[1] > 60) return '';
    try {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Argentina/Buenos_Aires', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(new Date()).map(part => [part.type, part.value]));
      const today = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
      const businessDays = count => { const date = new Date(today); for (let added = 0; added < count;) { date.setUTCDate(date.getUTCDate() + 1); if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) added++; } return date; };
      const format = new Intl.DateTimeFormat('es-AR', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' });
      const longDate = date => { const fields = Object.fromEntries(format.formatToParts(date).map(part => [part.type, part.value])); return `${fields.weekday} ${fields.day} de ${fields.month}`; };
      return `Llega entre el ${longDate(businessDays(days[0]))} y el ${longDate(businessDays(days[1]))}`;
    } catch { return ''; }
  }
  // Como no Projeto Final: "Nombre Apellido, Calle 123, Piso, CP Ciudad, Provincia, Argentina" (igual ao do servidor).
  const addressText = buyer => [[buyer.firstName, buyer.lastName].map(v => String(v || '').trim()).filter(Boolean).join(' '), [buyer.address1.trim(), buyer.streetNumber.trim()].join(' '), buyer.address2.trim(), [buyer.postalCode.trim().toUpperCase(), buyer.city.trim()].filter(Boolean).join(' '), buyer.province, 'Argentina'].filter(Boolean).join(', ');
  // Mesmo cartão do Projeto Final: rádio, nome com o prazo embaixo e o preço (GRATIS quando zero).
  function renderGroups(groups) {
    shippingGroups.replaceChildren();
    groups.forEach((group, index) => {
      if (groups.length > 1) { const title = document.createElement('p'); title.className = 'cp-shipping-group-title'; title.textContent = `Envío ${index + 1}`; shippingGroups.append(title); }
      const list = document.createElement('div'); list.className = 'cp-shipping';
      for (const option of group.options) {
        const label = document.createElement('label'); label.className = 'cp-shipping-option';
        const input = document.createElement('input'); input.type = 'radio'; input.name = `pilot-shipping-${index}`; input.value = option.handle;
        input.dataset.shippingGroup = group.id; input.checked = group.selectedHandle === option.handle;
        const copy = document.createElement('span'); copy.className = 'cp-shipping-copy';
        const title = document.createElement('strong'); title.textContent = option.title; copy.append(title);
        const estimate = deliveryEstimate(option.days);
        if (estimate) { const when = document.createElement('small'); when.textContent = estimate; copy.append(when); }
        const amount = document.createElement('span'); amount.className = 'cp-shipping-price'; amount.textContent = option.amountMinor === 0 ? 'GRATIS' : money(option.amountMinor);
        label.append(input, copy, amount); list.append(label);
      }
      if (!group.options.length) list.textContent = 'No hay opciones de envío disponibles para esta dirección.';
      shippingGroups.append(list);
    });
    if (!groups.length) shippingGroups.textContent = 'No hay opciones de envío disponibles para esta dirección.';
  }
  // Tarifas conhecidas (última preparação no servidor ou nesta visita): só para mostrar na hora do clique.
  let knownRates = null;
  const ratesValid = rates => Array.isArray(rates) && rates.length > 0 && rates.length <= 10 && rates.every(rate => rate && typeof rate.title === 'string' && rate.title && Number.isSafeInteger(rate.amountMinor) && rate.amountMinor >= 0);
  if (nativeShipping) fetch('/api/pilot/rates', { credentials: 'same-origin' }).then(response => response.ok ? response.json() : null)
    .then(data => { if (!knownRates && ratesValid(data?.rates)) knownRates = data.rates; }).catch(() => {});
  // Projeto Final: a etapa troca no clique. As opções aparecem na hora (as conhecidas, travadas, ou cartões
  // cinza) e são trocadas pelas reais da Shopify assim que chegam — normalmente já montadas antes do clique.
  function openShippingStep(buyer) {
    loadingShipping = true;
    shippingState = null;
    if (buyer) {
      root.querySelector('[data-shipping-address]').textContent = addressText(buyer);
      const contact = root.querySelector('[data-shipping-contact]');
      if (contact) contact.textContent = buyer.email.trim();
    }
    if (knownRates) {
      const options = knownRates.map((rate, index) => ({ ...rate, handle: `conocida-${index}` }));
      const chosen = options.find(option => option.amountMinor === 0) || options.reduce((best, option) => option.amountMinor < best.amountMinor ? option : best);
      renderGroups([{ id: 'conocidas', selectedHandle: chosen.handle, options }]);
      shippingGroups.firstChild?.setAttribute?.('aria-busy', 'true');
    } else {
      const list = document.createElement('div'); list.className = 'cp-shipping'; list.setAttribute('aria-busy', 'true');
      for (let index = 0; index < 2; index++) { const placeholder = document.createElement('div'); placeholder.className = 'cp-shipping-option cp-skeleton'; list.append(placeholder); }
      shippingGroups.replaceChildren(list);
    }
    showShippingStep(true);
    drawTotals();
    updateControls();
    try { window.scrollTo(0, 0); } catch {}
  }
  // Falha ao abrir o envío: volta para onde o cliente estava, mantendo a capacidade quando um retry é seguro.
  function failShipping(error, returnToInformation) {
    loadingShipping = false;
    if (!retainShipping(error)) discardShipping();
    else if (returnToInformation) { shippingState = null; showShippingStep(false); }
    else { shippingGroups.replaceChildren(); drawButton(); }
    message.textContent = cart && !cart.items.length ? 'Tu carrito está vacío. Volvé a la tienda para agregar productos.' : error.message;
  }
  function drawShipping(data, focus = false) {
    shippingState = validateShipping(data);
    if (data !== previousDrawn) shippingConfirmedAt = Date.now();
    previousDrawn = data;
    loadingShipping = false;
    saveShippingPhase('ready');
    root.querySelector('[data-shipping-address]').textContent = data.address;
    const contact = root.querySelector('[data-shipping-contact]');
    if (contact) contact.textContent = data.contact || form.elements.email?.value || '';
    renderGroups(data.groups);
    if (data.groups.length === 1 && ratesValid(data.groups[0].options)) knownRates = data.groups[0].options.map(({ title, amountMinor, days }) => ({ title, amountMinor, days }));
    showShippingStep(true);
    drawTotals();
    updateControls();
    if (focus) { try { root.querySelector('[data-shipping-title]').focus({ preventScroll: true }); } catch {} }
  }
  async function shippingRequest(action, selections) {
    const active = shippingSession;
    const version = shippingVersion;
    if (!active || active.fingerprint !== fingerprint(cart)) throw Object.assign(new Error('Tu carrito cambió. Revisá el resumen y continuá nuevamente.'), { invalidShipping: true });
    const response = await fetch('/api/pilot/shipping', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action, id: active.id, signature: active.signature, ...(selections ? { selections } : {}) }),
    });
    const terminalStatus = [403, 404, 405, 409, 413].includes(response.status);
    const data = await response.json().catch(() => { throw Object.assign(new Error('No pudimos confirmar el envío. Intentá nuevamente.'), { invalidShipping: terminalStatus }); });
    if (version !== shippingVersion || shippingSession !== active || active.fingerprint !== fingerprint(cart)) throw Object.assign(new Error('Tu carrito cambió. Revisá el resumen y continuá nuevamente.'), { invalidShipping: true });
    if (!response.ok) throw shippingFailure(data.error, terminalStatus);
    return data;
  }
  const invalidMessages = ['Solicitud de envío inválida.', 'Volvé a información para completar tu dirección.', 'Carrito de envío inválido.',
    'El carrito está vacío.', 'El carrito cambió. Volvé a información.', 'El precio del carrito cambió.', 'El importe del carrito cambió.',
    'El carrito no corresponde a esta compra.', 'No pudimos verificar el carrito de envío.', 'Provincia de envío inválida.',
    'Moneda de envío inválida.', 'Importe de envío inválido.', 'Destino de pago inválido.',
    'Las opciones de envío cambiaron. Volvé a información.', 'La tarifa auxiliar no está disponible para esta dirección.'];
  const shippingFailure = (text, terminal = false) => Object.assign(new Error(text || 'No pudimos confirmar el envío. Intentá nuevamente.'), {
    invalidShipping: terminal || invalidMessages.includes(text), shippingNotPrepared: text === 'Volvé a información para preparar el envío.' });
  function checkoutDestination(value) {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.origin !== root.dataset.checkoutOrigin || url.username || url.password ||
      !/^\/cart\/(?:c\/[a-zA-Z0-9_-]+\/?|\d+:[1-9]\d*(?:,\d+:[1-9]\d*)*\/?)$/.test(url.pathname)) throw new Error('No pudimos abrir el pago.');
    return url.href;
  }
  // Pagamento no domínio do checkout sem levar o endereço desta página (Referer): na Shopify o pedido e o checkout
  // não registram de onde o cliente veio. Link com rel="noreferrer"; a página mantém a política dela nas outras chamadas.
  // Só nas lojas com o catálogo externo (data-no-referrer); as outras abrem o pagamento como sempre.
  function openPayment(destination) {
    const link = document.createElement('a');
    if (root.dataset.noReferrer !== 'true' || !document.body || typeof link.click !== 'function') { location.assign(destination); return; }
    link.href = destination;
    link.rel = 'noreferrer';
    link.hidden = true;
    document.body.append(link);
    link.click();
    link.remove();
  }
  // "Volver a información": a compra montada fica em memória e volta na hora se nada mudar (sem novo intent
  // nem evento). Depois de F5 os campos estão vazios: aí é uma tentativa nova, como antes.
  function backToInformation() {
    if (submitting || !onShippingStep()) return;
    message.textContent = '';
    if (!shippingSession || shippingBuyerSnapshot === null || !shippingState) discardShipping();
    else {
      try { sessionStorage.removeItem(shippingKey); } catch {}
      showShippingStep(false);
      updateControls();
    }
    form.elements.email?.focus();
  }
  changeInformation?.addEventListener('click', backToInformation);
  informationStep?.addEventListener('click', backToInformation);
  shippingGroups?.addEventListener('change', async event => {
    const input = event.target;
    if (input.type !== 'radio' || !shippingState) return;
    if (submitting) { drawShipping(shippingState); return; }
    const previousState = shippingState;
    const selections = previousState.groups.flatMap(group => {
      const handle = group.id === input.dataset.shippingGroup ? input.value : group.selectedHandle;
      return handle === null ? [] : [{ groupId: group.id, handle }];
    });
    setBusy(true);
    message.textContent = '';
    try {
      const [, data] = await Promise.all([refreshCart(), shippingRequest('select', selections)]);
      drawShipping(data);
    } catch (error) {
      if (error.invalidShipping) discardShipping();
      else if (shippingSession && shippingState === previousState) {
        // A resposta pode falhar depois de a Shopify salvar: confirma o estado antes de liberar o pago.
        try { drawShipping(await shippingRequest('read')); }
        catch { discardShipping(); }
      }
      message.textContent = error.message;
    } finally { setBusy(false); }
  });

  toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(expanded));
    summary.classList.toggle('is-open', expanded);
  });
  function drawCart() {
    const products = root.querySelector('.cp-products');
    products.replaceChildren();
    for (const item of cart.items) {
      const product = document.createElement('div'); product.className = 'cp-product';
      const thumb = document.createElement('div'); thumb.className = 'cp-thumb';
      const thumbnail = item.image && imageUrl(item.image);
      if (thumbnail) {
        const image = document.createElement('img'); image.src = thumbnail; image.alt = item.product_title; thumb.append(image);
      }
      const qty = document.createElement('span'); qty.className = 'cp-qty'; qty.textContent = String(item.quantity); thumb.append(qty);
      const title = document.createElement('div'); title.className = 'cp-product-name';
      const name = document.createElement('strong'); name.className = 'cp-product-title'; name.textContent = item.product_title; title.append(name);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('small'); variant.textContent = item.variant_title; title.append(variant);
      }
      const price = document.createElement('strong'); price.className = 'cp-product-price'; price.textContent = money(item.original_line_price);
      product.append(thumb, title, price); products.append(product);
    }
    const count = cart.items.reduce((sum, item) => sum + item.quantity, 0);
    drawTotals();
    root.querySelectorAll('[data-order-count]').forEach(element => { element.textContent = `Tu pedido (${count} ${count === 1 ? 'producto' : 'productos'})`; });
    if (!count) products.textContent = 'Tu carrito está vacío.';
    updateControls();
  }
  async function refreshCart() {
    if (refreshPromise) return refreshPromise;
    let readSucceeded = false;
    refreshPromise = (async () => {
      const response = await fetch('/cart.js', { cache: 'no-store' });
      if (!response.ok) throw new Error('No pudimos leer tu carrito. Volvé al carrito e intentá nuevamente.');
      const next = await response.json();
      if (!Array.isArray(next.items)) throw new Error('No pudimos leer tu carrito.');
      cart = next;
      cartValid = true;
      readSucceeded = true;
      const changed = shippingSession && (shippingSession.fingerprint !== fingerprint(cart) || !cart.items.length);
      if (changed) discardShipping();
      drawCart();
      if (!cart.items.length) throw new Error('Tu carrito está vacío. Volvé a la tienda para agregar productos.');
      if (changed) throw new Error('Tu carrito cambió. Revisá el resumen y continuá nuevamente.');
    })().catch(error => { if (!readSucceeded) cartValid = false; updateControls(); throw error; }).finally(() => { refreshPromise = null; });
    return refreshPromise;
  }
  async function refreshOnReturn() {
    if (submitting) return;
    setBusy(true);
    try {
      await refreshCart();
      message.textContent = '';
      trackInitiateCheckout();
      if (nativeShipping) {
        if (shippingSession?.phase === 'preparing' && shippingBuyerSnapshot !== null && shippingBuyerSnapshot !== buyerSnapshot()) {
          discardShipping();
          return;
        }
        let saved;
        try { saved = JSON.parse(sessionStorage.getItem(shippingKey) || 'null'); } catch {}
        if (shippingSessionValid(saved) && saved.fingerprint === fingerprint(cart)) {
          if (shippingSession?.id !== saved.id) shippingBuyerSnapshot = null;
          shippingSession = { id: saved.id, signature: saved.signature, fingerprint: saved.fingerprint, phase: saved.phase === 'preparing' ? 'preparing' : 'ready' };
          // F5: o comprador já está no servidor. Não confundir autofill dos campos
          // ocultos com edição; "Volver a información" abre informação como uma tentativa nova.
          if (shippingBuyerSnapshot === null) showShippingStep(true);
          try {
            let data;
            try { data = await shippingRequest('read'); }
            catch (error) {
              if (shippingSession?.phase !== 'preparing' || !error.shippingNotPrepared || error.invalidShipping) throw error;
              data = await shippingRequest('prepare');
            }
            drawShipping(data);
          } catch (error) { if (!retainShipping(error)) discardShipping(); throw error; }
        } else if (saved) {
          discardShipping();
          message.textContent = 'Tu carrito cambió. Revisá el resumen y continuá nuevamente.';
        }
        if (!shippingSession) reserve();
      }
    } catch (error) { message.textContent = error.message; }
    finally { setBusy(false); }
  }
  const requestLines = () => cart.items.map(item => ({ variantId: String(item.variant_id), quantity: item.quantity }));
  // Reserva: ao abrir a página, o servidor já cria o pedido e o carrinho da Shopify (sem comprador e sem
  // rastreio). Quem completar os dados consome a reserva: na Shopify só faltam endereço e frete.
  let reservationPromise = null;
  function reserve() {
    if (!nativeShipping || reservationPromise || !cart?.items?.length || shippingSession) return;
    const print = fingerprint(cart);
    const attribution = readAttribution();
    reservationPromise = fetch('/api/pilot/checkout', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lines: requestLines(), attribution, browser: browserSignals(attribution), withShipping: true, reserve: true }),
    }).then(response => response.ok ? response.json() : null)
      .then(data => shippingSessionValid(data?.reservation) ? { id: data.reservation.id, signature: data.reservation.signature, fingerprint: print } : null)
      .catch(() => null);
  }
  // Vale uma vez e só para o mesmo carrinho; se o servidor recusar, ele mesmo segue com pedido novo.
  async function takeReservation() {
    const value = reservationPromise ? await reservationPromise : null;
    if (!value || value.used || value.fingerprint !== fingerprint(cart)) return null;
    value.used = true;
    return { id: value.id, signature: value.signature };
  }
  // Monta o pedido em segundo plano quando os dados ficam completos (até 3 vezes por visita). Não rastreia
  // nada e não muda a tela: no clique, o mesmo comprador e carrinho usam este resultado na hora.
  function startAhead() {
    if (!nativeShipping || submitting || onShippingStep() || aheadCount >= 3 || !cartValid || !cart?.items?.length || !informationReady()) return;
    const buyer = formBuyer();
    const snapshot = JSON.stringify(buyer);
    const print = fingerprint(cart);
    const key = snapshot + '|' + print;
    if (ahead?.key === key || (shippingSession && shippingBuyerSnapshot === snapshot && shippingSession.fingerprint === print)) return;
    aheadCount++;
    const attribution = readAttribution();
    const lines = requestLines();
    const promise = takeReservation().then(reservation => fetch('/api/pilot/checkout', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lines, attribution, browser: browserSignals(attribution), buyer, withShipping: true, speculative: true, ...(reservation ? { reservation } : {}) }),
    })).then(async response => {
      const data = await response.json().catch(() => null);
      if (!response.ok || !data) throw new Error(data?.error || 'No pudimos preparar el envío.');
      return data;
    });
    promise.catch(() => {});
    ahead = { key, promise };
  }
  function scheduleAhead() {
    if (!nativeShipping || onShippingStep()) return;
    clearTimeout(aheadTimer);
    aheadTimer = setTimeout(startAhead, aheadDelay);
  }
  // Como no Projeto Final: digitar limpa o erro do campo; sair do campo confere de novo.
  informationPanel?.addEventListener('input', event => { if (REQUIRED_FIELDS.includes(event.target?.name)) setError(event.target.name, ''); scheduleAhead(); });
  informationPanel?.addEventListener('change', event => { if (REQUIRED_FIELDS.includes(event.target?.name)) setError(event.target.name, fieldError(event.target.name)); scheduleAhead(); });
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      submitting = false;
      shippingVersion++;
      setBusy(false);
      refreshOnReturn();
    }
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshOnReturn(); });
  async function pay() {
    if (!allShippingSelected()) return;
    // Tudo já preparado no servidor (carrinho, endereço, frete salvo e faturamento): o clique vai direto ao
    // pagamento da Shopify. Carrinho mudado em outra aba já foi conferido ao voltar para esta aba; estado com
    // mais de 30 min passa antes pela conferência no servidor (o intent vence em 24 h).
    if (shippingState.checkoutUrl && Date.now() - shippingConfirmedAt < 30 * 60 * 1000) {
      let destination = null;
      try { destination = checkoutDestination(shippingState.checkoutUrl); } catch {}
      if (destination) { setBusy(true, true); message.textContent = ''; openPayment(destination); return; }
    }
    const shownState = shippingState;
    const selections = shownState.groups.map(group => ({ groupId: group.id, handle: group.selectedHandle }));
    setBusy(true, true);
    message.textContent = '';
    try {
      const [, data] = await Promise.all([refreshCart(), shippingRequest('checkout', selections)]);
      const confirmed = validateShipping(data.shipping);
      const sameSelection = confirmed.groups.length === shownState.groups.length && shownState.groups.every(group =>
        confirmed.groups.some(next => next.id === group.id && next.selectedHandle === group.selectedHandle));
      drawShipping(confirmed);
      if (!sameSelection || confirmed.shippingMinor !== shownState.shippingMinor || confirmed.totalMinor !== shownState.totalMinor) {
        message.textContent = 'Las opciones o el total del envío cambiaron. Revisá el resumen y continuá nuevamente.';
        setBusy(false);
        return;
      }
      openPayment(checkoutDestination(data.checkoutUrl));
    } catch (error) {
      if (error.invalidShipping) discardShipping();
      message.textContent = cart && !cart.items.length ? 'Tu carrito está vacío. Volvé a la tienda para agregar productos.' : error.message;
      setBusy(false);
    }
  }
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (submitting || !cartValid || !cart?.items?.length) return;
    if (onShippingStep() && shippingState) { await pay(); return; }
    const buyer = formBuyer();
    const currentBuyerSnapshot = JSON.stringify(buyer);
    const fromInformation = !onShippingStep();
    if (nativeShipping && shippingSession) {
      const sameBuyer = shippingBuyerSnapshot === null ? !fromInformation : shippingBuyerSnapshot === currentBuyerSnapshot;
      // Voltou de envío sem mudar nada: a compra montada reaparece na hora (o pago confere tudo de novo).
      if (shippingState && fromInformation && sameBuyer && shippingSession.fingerprint === fingerprint(cart)) {
        saveShippingPhase('ready');
        drawShipping(shippingState);
        try { window.scrollTo(0, 0); } catch {}
        return;
      }
      if (shippingSession.fingerprint === fingerprint(cart) && (shippingSession.phase === 'preparing' || !shippingState) && (shippingBuyerSnapshot === null || sameBuyer)) {
        openShippingStep(shippingBuyerSnapshot === null ? null : buyer);
        setBusy(true);
        message.textContent = '';
        try {
          await refreshCart();
          if (shippingBuyerSnapshot !== null && shippingBuyerSnapshot !== buyerSnapshot()) throw Object.assign(new Error('Tus datos cambiaron. Revisalos y continuá nuevamente.'), { invalidShipping: true });
          drawShipping(await shippingRequest(shippingSession.phase === 'preparing' ? 'prepare' : 'read'), true);
        } catch (error) { failShipping(error, fromInformation); }
        finally { setBusy(false); }
        return;
      }
      discardShipping();
    }
    if (!validateInformation()) return;
    clearTimeout(aheadTimer);
    message.textContent = '';
    const previous = fingerprint(cart);
    const key = currentBuyerSnapshot + '|' + previous;
    const prepared = nativeShipping && ahead?.key === key ? ahead.promise : null;
    ahead = null;
    if (nativeShipping) { openShippingStep(buyer); setBusy(true); } else setBusy(true, true);
    try {
      // Conferência do carrinho (outra aba pode ter mudado) em paralelo com a montagem do pedido:
      // o clique espera a mais lenta das duas, não a soma. Carrinho diferente = não segue.
      const cartCheck = refreshCart();
      let data = prepared ? (await Promise.all([cartCheck, prepared.catch(() => null)]))[1] : null;
      const speculative = Boolean(data && shippingSessionValid(data.shippingSession));
      if (!speculative) {
        const attribution = readAttribution();
        const lines = requestLines();
        const [, response] = await Promise.all([cartCheck, (nativeShipping ? takeReservation() : Promise.resolve(null)).then(reservation => fetch('/api/pilot/checkout', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ lines, attribution, browser: browserSignals(attribution), buyer, ...(nativeShipping ? { withShipping: true } : {}), ...(reservation ? { reservation } : {}) }),
        }))]);
        data = await response.json().catch(() => ({ error: 'No pudimos abrir el pago ahora. Intentá nuevamente.' }));
        if (!response.ok) throw new Error(data.error || 'No pudimos abrir el pago.');
      }
      if (fingerprint(cart) !== previous) throw new Error('Tu carrito cambió. Revisá el resumen y continuá nuevamente.');
      const destination = checkoutDestination(data.checkoutUrl);
      if (nativeShipping) {
        if (!shippingSessionValid(data.shippingSession)) throw new Error('No pudimos preparar el envío. Intentá nuevamente.');
        shippingSession = { id: data.shippingSession.id, signature: data.shippingSession.signature, fingerprint: previous, phase: 'preparing' };
        shippingBuyerSnapshot = currentBuyerSnapshot;
        saveShippingPhase('preparing');
      }
      trackAddPaymentInfo(data.tracking);
      if (speculative) confirmAddPaymentInfo(shippingSession);
      if (!nativeShipping) { openPayment(destination); return; }
      if (shippingBuyerSnapshot !== buyerSnapshot()) throw Object.assign(new Error('Tus datos cambiaron. Revisalos y continuá nuevamente.'), { invalidShipping: true });
      // Normalmente o envío já veio montado; se a Shopify falhou naquela hora, repete só o prepare.
      drawShipping(data.shipping || await shippingRequest('prepare'), true);
      setBusy(false);
    } catch (error) {
      if (nativeShipping) failShipping(error, true);
      else message.textContent = error.message;
      setBusy(false);
    }
  });
  refreshOnReturn();
})();
